export default "__VITE_PUBLIC_ASSET__33a6ad91__"